export default {
	state: {
		bankList: [],
	},
	mutations: {
		bankModify(state, data) {
			state.bankList = data
		}
	}
}